import React from 'react'
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'

const StoreIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg
        width="16"
        height="17"
        viewBox="0 0 16 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.33101 0.975342C2.70234 0.975342 2.12187 1.31305 1.81057 1.85869L0.104322 4.85413C-0.015426 5.06435 -0.0264073 5.31944 0.0748304 5.53917C0.666242 6.82285 1.95904 7.72534 3.47601 7.72534C4.33353 7.72534 5.11399 7.43254 5.73801 6.95295C6.36204 7.43254 7.14249 7.72534 8.00001 7.72534C8.85733 7.72534 9.63723 7.43323 10.2611 6.95386C10.8852 7.43327 11.6655 7.72534 12.522 7.72534C14.0378 7.72534 15.3317 6.82298 15.9232 5.53917C16.0244 5.31956 16.0135 5.06463 15.8939 4.85446L14.1895 1.85869C13.8777 1.31233 13.2959 0.975342 12.668 0.975342H3.33101ZM1.61631 5.23034L3.11345 2.602C3.15817 2.52368 3.24171 2.47534 3.33101 2.47534H12.668C12.7581 2.47534 12.8422 2.52454 12.8866 2.602L14.3818 5.23009C13.9769 5.83215 13.295 6.22534 12.522 6.22534C11.8492 6.22534 11.2472 5.92188 10.8287 5.4372C10.6862 5.27219 10.479 5.17734 10.261 5.17734C10.043 5.17734 9.8358 5.27219 9.69333 5.4372C9.27475 5.92199 8.67365 6.22534 8.00001 6.22534C7.32667 6.22534 6.72448 5.92123 6.30569 5.4362C6.16322 5.27119 5.95601 5.17634 5.73801 5.17634C5.52001 5.17634 5.3128 5.27119 5.17033 5.4362C4.75154 5.92123 4.14936 6.22534 3.47601 6.22534C2.7024 6.22534 2.02114 5.83233 1.61631 5.23034Z"
          fill="#8F8E8A"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.75 8.72534C3.16421 8.72534 3.5 9.06113 3.5 9.47534V15.4753H5.5V12.9753C5.5 11.5951 6.61979 10.4753 8 10.4753C9.38021 10.4753 10.5 11.5951 10.5 12.9753V15.4753H12.5V9.47534C12.5 9.06113 12.8358 8.72534 13.25 8.72534C13.6642 8.72534 14 9.06113 14 9.47534V15.4753H15.25C15.6642 15.4753 16 15.8111 16 16.2253C16 16.6396 15.6642 16.9753 15.25 16.9753H0.75C0.335786 16.9753 0 16.6396 0 16.2253C0 15.8111 0.335786 15.4753 0.75 15.4753H2V9.47534C2 9.06113 2.33579 8.72534 2.75 8.72534ZM9 15.4753V12.9753C9 12.4236 8.55179 11.9753 8 11.9753C7.44821 11.9753 7 12.4236 7 12.9753V15.4753H9Z"
          fill="#8F8E8A"
        />
      </svg>
    </SvgIcon>
  )
}

export default StoreIcon
